import { render, staticRenderFns } from "./AdminSupport.vue?vue&type=template&id=046775b1&scoped=true&"
import script from "./AdminSupport.vue?vue&type=script&lang=ts&"
export * from "./AdminSupport.vue?vue&type=script&lang=ts&"
import style0 from "./AdminSupport.vue?vue&type=style&index=0&id=046775b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046775b1",
  null
  
)

export default component.exports